export default {
    name: 'BulkAction',
    props: {
        module: {
            type: String
        },
        changeAction: {
            type: Function
        },
        selectedValue: {
            type: String
        }
    },
    data() {
        return {
            action: ''
        }
    },
    watch: {
     selectedValue (option) {
        this.action = option
     }   
    }
}